import PropTypes from 'prop-types'
import React from 'react'
import ModalWithAnimation from './ModalWithAnimation'
import { Button } from '../../atoms/Button'
import { Close } from '@mui/icons-material'
import clsx from 'clsx'

const AcceptCloseModal = ({
  title,
  buttonLabel = 'Aceptar',
  onAccept,
  onClose,
  children,
  open,
  contentAlignment = 'center'
}) => {
  const titleAlignment = `text-${contentAlignment}`
  const bodyAlignment = `text-${contentAlignment} justify-${contentAlignment}`
  return (
    <ModalWithAnimation size="m" open={open}>
      <div className="text-right">
        <Button
          type="button"
          variant="text"
          size="xs"
          className="font-bold -right-6"
          endIcon={<Close />}
          onClick={onClose}
        >
          Cerrar
        </Button>
      </div>
      <div className="w-full">
        <h2 className={clsx('header font-bold text-xl mb-4', titleAlignment)}>{title}</h2>
        <div className={clsx('body overflow-y-auto max-h-96 md:max-h-168 mb-6 flex px-6 md:px-0', bodyAlignment)}>
          {children}
        </div>
        <div className="footer flex justify-center">
          <Button type="button" size="m" onClick={onAccept} data-testid="confirm-button">
            {buttonLabel}
          </Button>
        </div>
      </div>
    </ModalWithAnimation>
  )
}
export default AcceptCloseModal

AcceptCloseModal.propTypes = {
  buttonLabel: PropTypes.string,
  children: PropTypes.node,
  onAccept: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  title: PropTypes.string,
  contentAlignment: PropTypes.string
}
